import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
  offerContainer: {
    textAlign: "center",
    "&.advertising-offer": {
      "& $offerTitle": {
        color: "#FFFFFF"
      }
    }
  },
  offerTitle: {
    marginBottom: 24,
    "@media (max-width: 1200px)": {
      marginBottom: 24
    }
  },
  offerButton: {
    minWidth: 288,
    marginLeft: "auto",
    marginRight: "auto",
    "@media (max-width: 600px)": {
      width: "100%"
    }
  }
});
